
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/utmb-index",
      function () {
        return require("private-next-pages/utmb-index/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/utmb-index"])
      });
    }
  